// "Requisition approved": the slip that drops in when a commendation is filed mid-run. One at a
// time, queued, never takes input, sits clear of the HUD's centre so it can't hide a robot.

import { Commendation, rankOf, rewardLabel } from '../../sim/progression';

const CSS = `
.req-slip { position: fixed; top: 14vh; left: 50%; z-index: 30; pointer-events: none; min-width: 300px; max-width: min(440px, calc(100vw - 32px));
  transform: translate(-50%, -14px); opacity: 0; transition: transform .28s cubic-bezier(.2,.9,.3,1.2), opacity .2s;
  padding: 10px 16px 11px; background: rgba(14,18,16,0.78); border: 1px solid rgba(250,199,125,0.55); border-left: 4px solid #fac77d;
  border-radius: 3px; backdrop-filter: blur(5px); box-shadow: 0 14px 40px rgba(0,0,0,0.4); color: #f0e6c8; font-family: 'Space Grotesk', system-ui, sans-serif; }
.req-slip.on { transform: translate(-50%, 0); opacity: 1; }
@media (prefers-reduced-motion: reduce) { .req-slip { transition: none; } }
.req-slip .k { font: 700 11px 'Space Grotesk'; letter-spacing: 3px; color: rgba(250,199,125,0.85); text-transform: uppercase; }
.req-slip .n { font-family: 'Space Grotesk', sans-serif; font-weight: 600; letter-spacing: 0.5px; font-size: 24px; color: #ffe6b0; line-height: 1.1; margin-top: 2px; }
.req-slip .r { font-size: 16px; margin-top: 3px; color: rgba(240,230,200,0.92); }
.req-slip .r b { color: #fac77d; }
.req-slip .p { font-size: 12px; letter-spacing: 2px; color: rgba(240,230,200,0.55); text-transform: uppercase; margin-top: 5px; }
`;

let css = false;
const queue: { c: Commendation; rank: string | null }[] = [];
let busy = false;

/** `promoted` = the new rank name when this commendation also moved you up a rank. */
export function requisitionToast(c: Commendation, held: number) {
  const prev = rankOf(held - 1).name, now = rankOf(held).name;
  queue.push({ c, rank: prev !== now ? now : null });
  if (!busy) next();
}

function next() {
  const item = queue.shift();
  if (!item) { busy = false; return; }
  busy = true;
  if (!css) { css = true; const s = document.createElement('style'); s.textContent = CSS; document.head.appendChild(s); }
  const el = document.createElement('div');
  el.className = 'req-slip';
  const how = item.c.scope === 'posse' ? 'Filed for the whole posse' : 'Filed to your record';
  el.innerHTML = `<div class="k">G.U.L.P. requisition approved</div><div class="n"></div><div class="r"></div><div class="p">${how}${item.rank ? ` · promoted to <b></b>` : ''}</div>`;
  (el.querySelector('.n') as HTMLElement).textContent = item.c.name;
  const r = el.querySelector('.r') as HTMLElement;
  const label = rewardLabel(item.c.reward);
  const i = label.indexOf(':');
  r.innerHTML = `${label.slice(0, i + 1)} <b></b>`;
  (r.querySelector('b') as HTMLElement).textContent = label.slice(i + 2);
  if (item.rank) (el.querySelector('.p b') as HTMLElement).textContent = item.rank;
  document.body.appendChild(el);
  void el.offsetWidth; // flush styles so the slide-in transition runs
  el.classList.add('on');
  setTimeout(() => { el.classList.remove('on'); setTimeout(() => { el.remove(); next(); }, 300); }, 4200);
}
